import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Product from "../../Componinets/Slideproduct/Product";
import "./CategoryPage.css";
import SlideProductLoading from "../../Componinets/Slideproduct/SlideProductLoading";
import PageTransion from "../../Componinets/PageTransion";

function Categorypage() {
  let { category } = useParams();

  let [categoryProdicts, setcategoryProdicts] = useState([]);
  let [loading, setloaing] = useState(true);

  useEffect(() => {
    fetch(`https://dummyjson.com/products/category/${category}`)
      .then((res) => res.json())
      .then((data) => {
        setcategoryProdicts(data);
      })
      .catch((error) => console.error(error))
      .finally(() => setloaing(false));
  }, [category]);

  return (
    <PageTransion key={category}>
      <div className="category_Prodicts">
        {loading ? (
          <SlideProductLoading key={category} />
        ) : (
          <div className="Container">
            <div className="top_slide">
              <h2>
                {category} : {categoryProdicts.limit}
              </h2>
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nihil
                alias, corrupti culpa cum et maiores veritatis in nemo, odit
                laboriosam voluptas totam quod, commodi quas dolores. Officia
                neque distinctio non.
              </p>
            </div>
            <div className="Prodicts">
              {categoryProdicts.products.map((item, index) => (
                <Product item={item} key={index} />
              ))}
            </div>
          </div>
        )}
      </div>
    </PageTransion>
  );
}

export default Categorypage;
